import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const end = this.element.value.length;
    this.element.focus();
    this.element.setSelectionRange(end, end);
  }
}
